export const BACKEND_HOST = `https://api.fondhilal.me`
export const DONIRAJ_URL = `https://vaktija.me/donations/hilal/`
